export const PHONE_RU = /\+7 [0-9]{3} [0-9]{3}-[0-9]{2}-[0-9]{2}/;
export const PHONE_RU_EXT = /[+]?7[\s]?[0-9]{3}[\s]?[0-9]{3}[-]?[0-9]{2}[-]?[0-9]{2}/;
export const PHONE_UA = /\+38 0[0-9]{2} [0-9]{3}-[0-9]{2}-[0-9]{2}/;

export const SMS_CODE = /\d \d \d \d/;

export const WHITE_SPACES = /\s+/g;

